import { render, staticRenderFns } from "./WishListContents.vue?vue&type=template&id=2104f1c1&"
import script from "./WishListContents.vue?vue&type=script&lang=js&"
export * from "./WishListContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports